import { render, staticRenderFns } from "./ShipmentRatingModal.vue?vue&type=template&id=6aec8d0d&scoped=true&"
import script from "./ShipmentRatingModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentRatingModal.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentRatingModal.vue?vue&type=style&index=0&id=6aec8d0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec8d0d",
  null
  
)

export default component.exports